const LoginStyles = theme => ({
  root: {
    flexGrow: 1,
    padding: "2rem"
  },
  formBtnHidden: {
    display: "none"
  }
});

export default LoginStyles;
